import { render, staticRenderFns } from "./TableResumenHoras.vue?vue&type=template&id=2f5be333&scoped=true&"
import script from "./TableResumenHoras.vue?vue&type=script&lang=js&"
export * from "./TableResumenHoras.vue?vue&type=script&lang=js&"
import style0 from "./TableResumenHoras.vue?vue&type=style&index=0&id=2f5be333&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5be333",
  null
  
)

export default component.exports